export enum DownloadOutputType {
  KML = 'kml',
  SHAPEFILE = 'shapefile',
  GEOJSON = 'geojson'
}
